import React from 'react';
import type { PatientRecord } from '../../../patients/types';
import { PatientProfileSectionCard } from '../PatientProfileSectionCard';

export interface PatientComfortCardProps {
  patient: PatientRecord;
  updatedAt?: string | undefined;
}

/**
 * Comfort preferences — coffee, music, blanket, sedation.
 *
 * These were already on `PatientRecord` and populated in every fixture, but
 * rendered nowhere: dead data since the type was written. They are exactly the
 * front desk's job ("offer her a blanket, she takes nitrous"), so they render
 * here as one compact row rather than being deleted.
 */
export function PatientComfortCard({ patient: p, updatedAt }: PatientComfortCardProps) {
  if (!p.comfort.length) return null;

  return (
    <PatientProfileSectionCard
      icon="heart"
      title="Comfort"
      accent="var(--gold)"
      {...(updatedAt ? { subtitle: `Updated ${updatedAt}` } : {})}
    >
      <div className="flex flex-wrap gap-1.5">
        {p.comfort.map(([k, v]) => (
          <span
            key={k}
            className="inline-flex items-center gap-1.5 rounded-[var(--r-pill)] border border-[var(--cream-2)] bg-[var(--cream-0)] px-[11px] py-1 text-[12.5px]"
          >
            <span className="text-[var(--ink-3)]">{k}</span>
            <span className="font-semibold text-[var(--ink-1)]">{v}</span>
          </span>
        ))}
      </div>
    </PatientProfileSectionCard>
  );
}
